export function amountToCurrency(amount: number, cSymbol: string, decimals: number = 2): string {
    const value = parseFloat(String(amount)).toFixed(decimals).replace("-", "");
    const negativeSign = amount < 0 ? "-" : "";

    return `${negativeSign} ${cSymbol}${value}`;
}
